/**
 * 获取指定车型详细参数
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆基本信息
// 接口地址  /api/v1/used_car/ticket/car_infos/<int:car_info_id>/meta
// Mock.mock(/\/auctions\/\d+\/brief/, 'get' + mockSwitch, {
//   'code': 0,
//   'message': 'ok',
//   'data': {
//     'details_ready': false,
//     'edited_at': '2018-01-08 13:32:51',
//     'id': 24,
//     'images_ready': false,
//     'inspections_ready': false,
//     'editor': {
//       'id': 68,
//       'mobile_number': '13534095201',
//       'name': '刘璇',
//       'role_id': null,
//       'role_name': '**引导员,**行政经理,hahah,场经理,续保专员,**总经理',
//       'store_name': '中升测试环境店铺'
//     }
//   }
// })

// 车辆到店评估
// 接口地址  /api/v1/used_car/ticket/car_info/{car_info_id}/meta
Mock.mock(/used_car\/ticket\/car_info\/\d+\/meta$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // # 快照 id
    'ticket_id': 1, // # 对应的线索id 可能为空
    'is_details_ready': { 'completed': true, 'saved': true },
    'is_images_ready': { 'completed': true, 'saved': true },
    'is_inspections_ready': { 'completed': true, 'saved': true },
    'is_purchase_ready': null,
    'latest_car_info_at': '2017-12-12 12:12:12', // # 最近编辑时间
    'latest_car_info_employee_name': '欧文', // # 最近评估人姓名
    'latest_car_info_employee_role': '风格灌灌' // # 最近评估人角色
  }
})

// 新增车辆评估
// 接口地址  /api/v1/auctions/car_infos/{car_info_id}
Mock.mock(/auctions\/car_infos\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // 车辆信息快照ID
    'auction_car_id': 22, // 对应车辆id，可能为空
    'is_details_ready': { 'completed': true, 'saved': true },
    'is_images_ready': { 'completed': true, 'saved': true },
    'is_inspections_ready': { 'completed': true, 'saved': true },
    'is_purchase_ready': { 'completed': true, 'saved': true },
    'latest_car_info_at': '2017-12-12 12:12:12', // 最近编辑时间
    'latest_car_info_employee_name': '服务费', // 最近评估人姓名
    'latest_car_info_employee_role': '更好呵呵' // 最近评估人角色
  }
})

// 车辆到店评估保存成功 used_car/ticket/car_info/1/status
// 接口地址  /api/v1/used_car/ticket/car_info/{car_info_id}/status
Mock.mock(/used_car\/ticket\/car_info\/\d+\/status$/, 'patch' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})

// 新增车辆评估保存成功
// 接口地址  /api/v1/auctions/car_infos/{car_info_id}
Mock.mock(/auctions\/car_infos\/\d+$/, 'patch' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_info_id': 1, //  车辆信息id
    'auction_car_id': 1 //  车辆id,用于在保存成功页点击'去询价'或'去拍卖'
  }
})

// 获取收到报价邀请的车商数
Mock.mock(/auctions\/car_infos\/\d+\/tagged_dealers$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'num_dealers': 10
  }
})
